import { render, staticRenderFns } from "./AmountDetailDeposit.vue?vue&type=template&id=6bdb506e&scoped=true&"
import script from "./AmountDetailDeposit.vue?vue&type=script&lang=ts&"
export * from "./AmountDetailDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./AmountDetailDeposit.vue?vue&type=style&index=0&id=6bdb506e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdb506e",
  null
  
)

export default component.exports